'use strict';

export let LinkEditarComponent = {
    selector: 'linkEditar',
    template: require('./link-editar.html'),
    bindings: {
        link: '@'
    },
    controller: class {

        /*@ngInject*/
        constructor(Auth) {
            this.isAdmin = Auth.isAdminSync;
        }
    }
};


// WEBPACK FOOTER //
// ./client/components/link-editar/link-editar.component.js